import type { SpatialImage } from '@/types';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

const SAFE_IMAGE = /^(https:\/\/|data:image\/(png|jpe?g|gif|webp|avif|svg\+xml);)/i;

export const ImageRenderer = ({ object: img }: ObjectRendererProps<SpatialImage>) =>
  SAFE_IMAGE.test(img.src) ? (
    <img className={styles.image} src={img.src} alt={img.alt} draggable={false} />
  ) : (
    <div className={styles.tile}>
      <span className={styles.tileMeta}>image source not allowed</span>
    </div>
  );
